module.exports = __webpack_public_path__ + "img/Slice38.b1dadcb4.png";